"use client";

import React from "react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { ImageType } from "@/types/baseTypes";
import { customSanitize } from "@/utils/customSanitize";
import { Button } from "@/components/Button/Button";
import { MediaItem } from "@/components/MediaItem/MediaItem";
import styles from "./RoomCard.module.scss";

export type RoomCardElement = {
  title: string;
  excerpt: string;
  image: ImageType | false;
  link: string;
};

interface RoomCardProps {
  element: RoomCardElement;
  headingLevel: number;
}

export const RoomCard = ({ element, headingLevel }: RoomCardProps) => {
  const { getLabel } = useGlobalContext();

  return (
    <article className={`${styles["room-card"]} is-box`}>
      <MediaItem
        image_desktop={element.image}
        sizes="(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 33vw"
        objectFit="cover"
        className={`${styles["media"]} auto-height`}
        showMediaInfo={false}
        link={
          element.link
            ? {
                url: element.link,
                target: "_self",
                title: "",
              }
            : false
        }
      />
      <div className={styles["content"]}>
        <p
          role="heading"
          aria-level={headingLevel}
          className={styles["title"]}
          dangerouslySetInnerHTML={{ __html: customSanitize(element.title) }}
        />
        {element.excerpt && (
          <p
            className={styles["excerpt"]}
            dangerouslySetInnerHTML={{
              __html: customSanitize(element.excerpt),
            }}
          />
        )}
        {element.link && (
          <footer className={styles["footer"]}>
            <Button
              type="secondary"
              aria-label={getLabel("aria_label_postlink").replace(
                `"$posttitle"`,
                element.title,
              )}
              href={element.link}
              target="_self"
              className={`${styles["link"]} my-0`}
            >
              {getLabel("room_link_label", "Mehr Infos")}
            </Button>
          </footer>
        )}
      </div>
    </article>
  );
};
